module.exports = __webpack_public_path__ + "static/img/01folder.bba2cb7a.png";